var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ag-grid-vue',{key:_vm.iteration,ref:_vm.name,class:_vm.classes,style:({ width: _vm.width, height: _vm.height }),attrs:{"name":_vm.name,"column-defs":_vm.columnDefs,"row-data":_vm.rowData,"grid-options":_vm.gridOptions}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-162ce44a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SigmaClientNew/PayrollStatusList.vue
// module id = cdMO
// module chunks = 1